import { useEffect, useMemo, useState } from 'react';

import type { NewsItem } from '../types/news';

const time = (item: NewsItem) => new Date(item.date).getTime();

export function useNewsHandbook(news: NewsItem[]) {
    const [activeId, setActiveId] = useState<string | null>(null);
    const [query, setQuery] = useState('');
    const [isNewestFirst, setNewestFirst] = useState(true);

    useEffect(() => {
        if (!news.length) return;

        const stillExists = news.some((item) => item.id === activeId);
        if (!stillExists) {
            setActiveId(news[0].id);
        }
    }, [news, activeId]);

    const visible = useMemo(() => {
        const needle = query.trim().toLowerCase();

        const filtered = needle === ''
            ? news
            : news.filter((item) => {
                const haystack = `${item.title} ${item.paragraphs.join(' ')}`.toLowerCase();
                return haystack.includes(needle);
            });

        return [...filtered].sort((a, b) =>
            isNewestFirst ? time(b) - time(a) : time(a) - time(b),
        );
    }, [news, query, isNewestFirst]);

    const activeItem = useMemo(
        () => news.find((item) => item.id === activeId) ?? null,
        [news, activeId],
    );

    return {
        activeItem,
        selectNews: setActiveId,
        query,
        setQuery,
        isNewestFirst,
        toggleOrder: () => setNewestFirst((value) => !value),
        isFiltered: query.trim() !== '',
        reset: () => setQuery(''),
        visible,
        total: news.length,
    };
}